import { memo } from 'react';
import styled from 'styled-components';
import { getScreenMaxHeight, getScreenMaxWidth } from '../../utils/bundle.esm3.js';

const ModalStyled = styled.div`
  position: fixed;
  background-color: ${(props) => {
  var _a;
  return (_a = props.color) != null ? _a : "#ffffff";
}};
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.height}px`};
  max-height: ${getScreenMaxHeight()};
  max-width: ${getScreenMaxWidth()};
  border-radius: 4px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  isolation: isolate;

  .Modal {
    &__header {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    &__close-icon {
      cursor: pointer;
      position: absolute;
      display: flex;
      align-items: center;
      top: 16px;
      right: 16px;
      z-index: 1;
    }

    &__body {
      flex: 1;
      overflow: auto;
      scrollbar-color: rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0);
      scrollbar-width: thin;

      &::-webkit-scrollbar {
        -webkit-appearance: none;
      }

      &::-webkit-scrollbar:vertical {
        width: 8px;
      }

      &::-webkit-scrollbar:horizontal {
        height: 8px;
      }

      &::-webkit-scrollbar-button:increment,
      .contenedor::-webkit-scrollbar-button {
        display: none;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #9b9b9b;
        border-radius: 24px;
        border: 2px solid #ffffff;
      }

      &::-webkit-scrollbar-track {
        border-radius: 8px;
      }
    }

    &__footer {
    }
  }
`;
var Styles = memo(ModalStyled);

export { Styles as default };
//# sourceMappingURL=bundle.esm2.js.map
